var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { elevation, gridSize, borderRadius } from "@atlaskit/theme";
import styled from "styled-components";
import { TextAlignCenterDiv } from "@atlassiansox/microscopekit";
var BaselineMetric = function (_a) {
    var metric = _a.metric, lowerBound = _a.lowerBound, upperBound = _a.upperBound, unit = _a.unit;
    var isMetricUnavailable = lowerBound === "No Data available";
    var isEqual = lowerBound === upperBound;
    return (React.createElement("div", null, isMetricUnavailable ? (React.createElement("text", null,
        React.createElement("b", null, metric),
        " : Data unavailable")) : isEqual ? (React.createElement("text", null,
        React.createElement("b", null, metric),
        " : ",
        lowerBound,
        unit,
        " ")) : (React.createElement("text", null,
        React.createElement("b", null, metric),
        " : ",
        lowerBound,
        unit,
        " - ",
        upperBound,
        unit))));
};
export var BaselineCard = function (_a) {
    var goldenSignal = _a.goldenSignal, img = _a.img, metrics = _a.metrics, data = _a.data, unit = _a.unit;
    var value = function (metric, type) {
        var _a;
        var metricValues = data === null || data === void 0 ? void 0 : data.baseline;
        return (_a = metricValues === null || metricValues === void 0 ? void 0 : metricValues[metric]) === null || _a === void 0 ? void 0 : _a[type];
    };
    return (React.createElement(Container, null,
        React.createElement(TextAlignCenterDiv, null,
            React.createElement("b", null, goldenSignal)),
        React.createElement(Img, { src: img, alt: goldenSignal, height: 30 }),
        metrics.map(function (metric) { return (React.createElement(BaselineMetric, { metric: metric.key, lowerBound: value(metric.value, "lower_bound"), upperBound: value(metric.value, "upper_bound"), unit: unit })); })));
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  border-radius: ", "px;\n  padding: ", "px;\n  width: 185px;\n  height: 110px;\n  margin-left: 10px;\n"], ["\n  ", "\n  border-radius: ", "px;\n  padding: ", "px;\n  width: 185px;\n  height: 110px;\n  margin-left: 10px;\n"])), elevation.e100, borderRadius(), gridSize() * 1.1);
var Img = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", "px;\n  display: block;\n  margin: auto auto;\n"], ["\n  padding: ", "px;\n  display: block;\n  margin: auto auto;\n"])), gridSize() * 1.25);
var templateObject_1, templateObject_2;
